import {useEffect, useState} from "react";
import {getSchoolRankList, getSchoolRank} from "../techlympicApi";
import View from "./View";

export default function Container({rankData, schoolData, dismiss}) {
  const [rankList, setRankList] = useState(null);
  const [rankDataPopup, setRankDataPopup] = useState(rankData);

  useEffect(() => {
    getRankList();
    if (schoolData && schoolData.school) {
      getRankData();
    }
  }, []);

  const getRankList = async () => {
    const response = await getSchoolRankList();
    setRankList(response.data);
  };

  const getRankData = async () => {
    const response = await getSchoolRank({school: schoolData.school});
    setRankDataPopup(response.data);
  };

  if (rankList && rankList.length > 0) {
    return <View rankData={rankDataPopup} rankList={rankList} dismiss={dismiss} />;
  } else {
    return <View rankData={rankDataPopup} rankList={[]} dismiss={dismiss} />;
  }
}
